import React from "react";
import PropTypes from "prop-types";
import useExtensionSurfacePreviewState from "../shared/useExtensionSurfacePreviewState";
import ExtensionUpsellWidget from "../shared/ExtensionUpsellWidget";
import {
  ExtensionOrderStatusSidebar,
  OrderStatusPageSkeleton,
  pageShellStyles,
} from "../shared/ExtensionPageChrome";
import { SURFACE_WIDGET_BADGES } from "../shared/extension-preview-dummy-data";
import styles from "./order-status-editor-preview.module.css";

export default function OrderStatusEditorPreview({
  popupData,
  popupState,
  setPopupState,
}) {
  const preview = useExtensionSurfacePreviewState({
    popupData,
    popupState,
    setPopupState,
  });

  return (
    <div
      ref={preview.popupRef}
      className={`${pageShellStyles.pageShell} ${
        preview.isMobile ? pageShellStyles.mobile : ""
      }`.trim()}
      data-testid="order-status-upsell-preview"
      data-extension-surface="ORDER_STATUS_PAGE"
    >
      <div className={pageShellStyles.mainPane}>
        <div className={pageShellStyles.mainInner}>
          <header className={styles.header}>
            <div>
              <h1 className={styles.title}>Order #1004</h1>
              <p className={styles.meta}>Confirmed 30 May</p>
            </div>
            <button type="button" className={styles.buyAgainBtn}>
              Buy again
            </button>
          </header>

          <ExtensionUpsellWidget
            surfaceBadge={SURFACE_WIDGET_BADGES.ORDER_STATUS_PAGE}
            mapped={preview.mapped}
            popupData={popupData}
            activeStep={preview.activeStep}
            currentParentData={preview.currentParentData}
            selectedBlock={preview.selectedBlock}
            handleBlockClick={preview.handleBlockClick}
            isSelected={preview.isSelected}
            renderCta={preview.renderCta}
          />

          <OrderStatusPageSkeleton />
        </div>
      </div>
      <ExtensionOrderStatusSidebar />
    </div>
  );
}

OrderStatusEditorPreview.propTypes = {
  popupData: PropTypes.object,
  popupState: PropTypes.object,
  setPopupState: PropTypes.func,
};
